export default __webpack_public_path__ + "static/media/notificacion.1c137a62.png";